<template>
  <div id="userProfile">
    <el-row class="header-row">
      <el-col :span="24">
        <h3 class="el-page-header">My Profile</h3>
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/my-profile' }">My Profile</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-card style="padding-bottom: 10px; min-height: 150px" v-loading="initialLoading || saving" element-loading-spinner="atom-audit-loader">
      <el-col :span="24">
        <el-form v-if="!initialLoading" style="margin-top: 16px" ref="form" label-position="left" label-width="280px" size="mini">
          <el-form-item v-if="isAuditor()" label="Disable Response Emails from Coder">
            <div class="profile-preference-row">
              <el-switch v-model="userProfile.profile.disableCoderResponse" active-color="#13ce66" inactive-color="#ff4949" :disabled="tenantSetup.disableAutomaticAuditorNotifications" @change="validUserProfile()"> </el-switch>
              <el-alert v-if="tenantSetup.disableAutomaticAuditorNotifications" class="profile-org-alert" title="Automatic auditor notifications are disabled by your organization." type="info" :closable="false" show-icon> </el-alert>
            </div>
          </el-form-item>
          <el-form-item v-if="coder()" label="Disable Rebuttal Emails from Auditor">
            <div class="profile-preference-row">
              <el-switch v-model="userProfile.profile.disableRebuttalEmails" active-color="#13ce66" inactive-color="#ff4949" :disabled="tenantSetup.disableAutomaticCoderNotifications" @change="validUserProfile()"> </el-switch>
              <el-alert v-if="tenantSetup.disableAutomaticCoderNotifications" class="profile-org-alert" title="Automatic coder notifications are disabled by your organization." type="info" :closable="false" show-icon> </el-alert>
            </div>
          </el-form-item>
        </el-form>
      </el-col>
    </el-card>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import HiaAuthorization from '@/mixins/hiaAuthorization'

  export default {
    name: 'UserProfile',
    mixins: [HiaAuthorization],
    data() {
      return {
        initialLoading: true,
        saving: false,
        setProfile: {
          profile: {},
          userId: 0
        }
      }
    },
    methods: {
      ...mapActions('userProfile/', ['GET_USERPROFILE', 'PUT_USERPROFILE', 'POST_USERPROFILE']),
      ...mapActions('managedLists/tenantSetup/', ['GET_TENANT_SETUP']),
      isAuditor() {
        return this.inpatientReviewer() || this.outpatientReviewer() || this.ambulatoryReviewer() || this.providerReviewer()
      },
      initialize() {
        const payload = {
          userId: this.currentTenantUserId
        }
        this.initialLoading = true
        Promise.all([this.GET_USERPROFILE(payload), this.GET_TENANT_SETUP()])
          .then(() => {
            if (this.userProfile.profile.disableRebuttalEmails === undefined) {
              this.$set(this.userProfile.profile, 'disableRebuttalEmails', false)
            }
            this.initialLoading = false
          })
          .catch(() => {
            this.initialLoading = false
          })
      },
      async validUserProfile() {
        try {
          if (this.userProfile.userId === null) {
            // post user profile
            this.setProfile.profile = JSON.stringify(this.userProfile.profile)
            const payload = {
              userId: this.currentTenantUserId,
              profile: this.setProfile.profile
            }
            this.saving = true
            await this.POST_USERPROFILE(payload)
            this.saving = false
          } else {
            // put user profile
            this.setProfile.userId = this.userProfile.userId
            this.setProfile.userProfileId = this.userProfile.userProfileId
            this.setProfile.profile = JSON.stringify(this.userProfile.profile)
            this.saving = true
            await this.PUT_USERPROFILE(this.setProfile)
            this.saving = false
          }
          this.$message({
            message: 'Profile Update Successful',
            type: 'success'
          })
        } catch (err) {
          console.log(err)
          this.saving = false
          this.$message({
            message: 'Reason for Change Added Error',
            type: 'error'
          })
        }
      }
    },
    created: function () {
      this.initialize()
    },
    computed: {
      ...mapState('userProfile/', ['userProfile']),
      ...mapState('user/', ['currentTenantUserId']),
      ...mapState('managedLists/tenantSetup/', ['tenantSetup'])
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .profile-preference-row {
    display: flex;
    align-items: center;
    gap: 16px;
    flex-wrap: wrap;
  }

  .profile-org-alert {
    flex: 1;
    min-width: 280px;
    max-width: 520px;
    padding: 4px 8px;
  }

  .profile-org-alert >>> .el-alert__icon {
    margin-right: 5px;
  }

  .profile-org-alert >>> .el-alert__content {
    padding: 0;
  }
</style>
